import ActionGroupDefault from '@ulta/core/components/ActionGroupDefault/ActionGroupDefault';

export default ActionGroupDefault;